'use client'
import React from 'react'
import { pageSectionTypes } from './pageSectionTypes'
import { Grid } from '@achieve/ascend'

export function ChildComponentGeneratorClient({ uiComponent, isCrawler = false, ...props }) {
  const SectionComponent = pageSectionTypes[uiComponent]
  if (!SectionComponent) {
    return null
  }
  return <SectionComponent content={{ ...props, isCrawler }} />
}

export function GridHandler({ gridContents, columns, ...gridProps }) {
  return (gridContents || []).map((gridContent, index) => {
    return (
      <Grid item xs={12 / columns} key={`${gridContent?.sys?.id}-${index}`} {...gridProps}>
        <ChildComponentGeneratorClient
          contentTypes={pageSectionTypes}
          uiComponent={gridContent.fields.uiComponent}
          {...gridContent}
        />
      </Grid>
    )
  })
}
